export default __webpack_public_path__ + "static/media/pagenotfound.b52252e1.svg";